import { render, staticRenderFns } from "./UiConfirmationDialog.vue?vue&type=template&id=1a7aad4f"
import script from "./UiConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./UiConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports